import { component, Component, property } from '../../../concepts/objects';

const phaseDef = {
    name: 'Phase',
    implements: [],
};

@component(phaseDef)
export class Phase extends Component {

    @property({ type: 'string' })
    public key!: string;

    @property({ type: 'string' })
    public name!: string;

    @property({ type: 'number' })
    public time!: number;

    @property({ type: 'string[]' })
    public tools!: string[];

    @property({ type: 'boolean' })
    public incognito!: boolean;

    @property({ type: 'boolean' })
    public concealment!: boolean;

    @property({ type: 'boolean' })
    public readyCheck!: boolean;

    @property({ type: 'boolean' })
    public timer!: boolean;
}
